import { Link, Stack, Typography } from "@mui/material";
import { MooneBetaLogo } from "Components/Beta/MooneBetaLogo";
import { ReportButtonPreview } from "Components/Beta/ReportButtonPreview";
import {
  getResourcePath,
  Resources,
  useResource,
} from "Translations/Resources";
import { Trans } from "react-i18next";

const RESOURCES = Resources.Beta.Drawer;

type Props = {
  isTitleHidden?: boolean;
};

export const BetaInfoContent = ({ isTitleHidden }: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={1}>
      <MooneBetaLogo />
      <Stack gap={3} width="100%" maxWidth={600} mx="auto">
        {!isTitleHidden && (
          <Typography variant="h5">{t(RESOURCES.Title)}</Typography>
        )}
        <Typography variant="body1">
          <Trans
            i18nKey={getResourcePath(RESOURCES.BodyFirst)}
            components={{
              reportButton: <ReportButtonPreview />,
            }}
          />
        </Typography>
        <Typography variant="body1">
          <Trans
            i18nKey={getResourcePath(RESOURCES.BodySecond)}
            components={{
              roadmap: (
                <Link
                  href={t(Resources.Beta.RoadmapUrl)}
                  target="_blank"
                  rel="noopener"
                  underline="hover"
                />
              ),
            }}
          />
        </Typography>
        <Typography variant="body1">{t(RESOURCES.BodyThird)}</Typography>
      </Stack>
    </Stack>
  );
};
